import React, { useState, useEffect, useRef } from "react";

const TeleprompterCountdown = ({ seconds = 3, onComplete }) => {
  const [count, setCount] = useState(seconds);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    if (count <= 0) {
      onCompleteRef.current();
      return;
    }
    const timer = setTimeout(() => setCount(count - 1), 1000);
    return () => clearTimeout(timer);
  }, [count]);

  return (
    <div className="absolute inset-0 flex items-center justify-center z-10 bg-forest-950/80">
      <span
        className="text-gold-500 font-bold animate-pulse"
        style={{ fontSize: "120px", lineHeight: 1 }}
      >
        {count}
      </span>
    </div>
  );
};

export default TeleprompterCountdown;
